import universal from 'react-universal-component';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';
import Loader from '@client/components/loader/Loader';
import LoaderFullScreen from '@client/components/loaderFullScreen/LoaderFullScreen';
import { getMainRoutes } from '@client/shared/utils/routerUtils/routerUtils';
import { withRestrictions } from '@client/helperComponents/restrict/withRestrictions';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
};

const fullLoaderOptions = {
  error: ErrorLoadingRouteChunk,
  loading: LoaderFullScreen,
};

const ROUTES = getMainRoutes();

export const campaignsRoutes = {
  path: `${ROUTES.CAMPAIGNS.TO}`,
  exact: false,
  componentPath: 'pages/campaignsPage/CampaignsPage',
  Component: withRestrictions({
    shouldBeLoggedIn: true,
  })(
    universal(import('pages/campaignsPage/CampaignsPage'), options),
    universal(import('pages/loginPage/LoginPage'), options)
  ),
  routes: [
    {
      path: `${ROUTES.CAMPAIGNS.TO}`,
      exact: true,
      componentPath:
        'pages/campaignsPage/activeCampaignRoute/ActiveCampaignRoute',
      Component: universal(
        import('pages/campaignsPage/activeCampaignRoute/ActiveCampaignRoute'),
        options
      ),
    },
    {
      path: `${ROUTES.CAMPAIGNS.ROUTES.ACTIVE.TO}`,
      exact: true,
      componentPath:
        'pages/campaignsPage/activeCampaignRoute/ActiveCampaignRoute',
      Component: universal(
        import('pages/campaignsPage/activeCampaignRoute/ActiveCampaignRoute'),
        options
      ),
    },
    {
      path: `${ROUTES.CAMPAIGNS.ROUTES.COMPLETED.TO}`,
      exact: true,
      componentPath:
        'pages/campaignsPage/completedCampaignRoute/CompletedCampaignRoute',
      Component: universal(
        import(
          'pages/campaignsPage/completedCampaignRoute/CompletedCampaignRoute'
        ),
        options
      ),
    },
    {
      path: `${ROUTES.CAMPAIGNS.ROUTES.DRAFT.TO}`,
      exact: true,
      componentPath:
        'pages/campaignsPage/draftCampaignRoute/DraftCampaignRoute',
      Component: universal(
        import('pages/campaignsPage/draftCampaignRoute/DraftCampaignRoute'),
        options
      ),
    },
    {
      path: `${ROUTES.CAMPAIGNS.ROUTES.CREATE.TO}`,
      exact: true,
      componentPath:
        'pages/campaignsPage/createCampaignRoute/CreateCampaignRoute',
      Component: universal(
        import('pages/campaignsPage/createCampaignRoute/CreateCampaignRoute'),
        fullLoaderOptions
      ),
    },
    {
      path: `${ROUTES.CAMPAIGNS.ROUTES.UPDATE.TO}/:campaignId`,
      exact: true,
      componentPath:
        'pages/campaignsPage/updateCampaignRoute/UpdateCampaignRoute',
      Component: universal(
        import('pages/campaignsPage/updateCampaignRoute/UpdateCampaignRoute'),
        fullLoaderOptions
      ),
    },
    {
      path: `${ROUTES.CAMPAIGNS.ROUTES.UPDATE.TO}/:campaignId/:tileIndex/:activeCampaign`,
      exact: true,
      componentPath:
        'pages/campaignsPage/updateCampaignRoute/UpdateCampaignRoute',
      Component: universal(
        import('pages/campaignsPage/updateCampaignRoute/UpdateCampaignRoute'),
        fullLoaderOptions
      ),
    },
  ],
};
